import useIntersectionObserver from '@react-hook/intersection-observer';
import React, { useRef, useEffect, useState, useCallback } from 'react';

export const useDelayedIntersectEffect = (
	ref: React.RefObject<HTMLElement> | null = null,
	callback?: () => void,
) => {
	const { isIntersecting } = useIntersectionObserver(ref, {
		threshold: 0.25,
	});

	const [visible, setVisible] = useState(false);
	const [focused, setFocused] = useState(false);
	// const [focus, setFocus] = useState(false);
	useEffect(() => {
		setVisible(document.visibilityState === 'visible');
		setFocused(document.hasFocus());
		const handler = () => setVisible(document.visibilityState === 'visible');
		document.addEventListener('visibilitychange', handler);
		const focusHandler = () => setFocused(true);
		const blurHandler = () => setFocused(false);
		window.addEventListener('focus', focusHandler);
		window.addEventListener('blur', blurHandler);
		return () => {
			document.removeEventListener('visibilitychange', handler);
			window.removeEventListener('focus', focusHandler);
			window.removeEventListener('blur', blurHandler);
		};
	}, []);
	// const isMountIntersecting = useRef(isIntersecting);

	const stopCheck = useRef(false);

	const $callback = useCallback(() => {
		if (stopCheck.current || !callback) return;
		stopCheck.current = true;
		// console.log('useDelayedIntersectEffect callback');
		callback();
	}, [callback]);

	// const timeoutc = useRef<number>();
	useEffect(() => {
		// console.log('useDelayedIntersectEffect', {
		// 	isIntersecting,
		// 	visible,
		// 	isMountIntersecting: isMountIntersecting.current,
		// 	// ref: $ref.current,
		// 	focus,
		// });
		if (!visible || !focused || !isIntersecting) return;
		// if (isMountIntersecting.current || focus) return $callback();
		$callback();

		// timeoutc.current = window.setTimeout(() => {
		// 	$callback();
		// }, 5000);
		// return () => {
		// 	window.clearTimeout(timeoutc.current);
		// };
	}, [isIntersecting, $callback, visible, focused]);
	// useEffect(() => {
	// 	return () => window.clearTimeout(timeoutc.current);
	// }, []);
};
